module.exports = __webpack_public_path__ + "static/img/m_channel.025f8b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/m_channel.png
// module id = m+Uz
// module chunks = 1